@if (loading()) {
  <app-cab-loading height="300px" />
} @else {
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="modal-body">
      <app-cab-autocomplete
        [_defaultService]="_regionService"
        label="GEOGRAPHY.DISTRICTS.TABLE_HEADERS.REGION"
        [controlName]="form.get('regionId')"
        [firstLoad]="true"
      />

      <div formArrayName="soatos" class="mb-2">
        <div class="gap-2 w-75">
          @for (soato of soatos.controls; track soato; let i = $index) {
            <div class="d-flex" [formGroupName]="i">
              <app-cab-input
                [controlName]="form.get('soatos.' + i)"
                mask="0*"
                label="GEOGRAPHY.MODAL_BUTTON.SOATO"
                class="w-75"
              />

              <div class="d-flex w-25">
                <app-cab-button
                  styleType="danger"
                  icon="cross-square"
                  [isLightIcon]="true"
                  [disabled]="soatos.length === 1"
                  (btnClick)="removeSoato(i)"
                  customClass="py-0 px-2 mt-9 ms-2"
                />

                @if (i === soatos.length - 1) {
                  <div class="ms-2">
                    <app-cab-button
                      (btnClick)="addSoato()"
                      icon="plus"
                      customClass="py-0 px-2 mt-9 ms-2"
                      [isLightIcon]="true"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <app-cab-input
        [controlName]="form.get('cadastralCode')"
        label="GEOGRAPHY.REGIONS.TABLE_HEADERS.CADASTRAL_CODE"
      />
      <div class="mt-7">
        <app-cab-tab>
          <div id="first">
            <app-cab-input
              [controlName]="form.get('name_uz')"
              type="text"
              label="GEOGRAPHY.DISTRICTS.MODAL.NAME_UZ"
            />
          </div>
          <div id="second">
            <app-cab-input
              [controlName]="form.get('name_crl')"
              type="text"
              label="GEOGRAPHY.DISTRICTS.MODAL.NAME_CRL"
            />
          </div>
          <div id="third">
            <app-cab-input
              [controlName]="form.get('name_ru')"
              type="text"
              label="GEOGRAPHY.DISTRICTS.MODAL.NAME_RU"
            />
          </div>
        </app-cab-tab>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 modal-footer">
      <app-cab-button
        [isPending]="isPending()"
        [disabled]="form.invalid"
        label="GEOGRAPHY.MODAL_BUTTON.ADD_BUTTON"
        styleType="success"
        type="submit"
      />

      <app-cab-button
        (btnClick)="onCancel()"
        type="reset"
        label="GEOGRAPHY.MODAL_BUTTON.CANCEL"
        styleType="light"
      />
    </div>
  </form>
}
